import { render, staticRenderFns } from "./render3D.vue?vue&type=template&id=10363294&scoped=true"
import script from "./render3D.vue?vue&type=script&lang=ts"
export * from "./render3D.vue?vue&type=script&lang=ts"
import style0 from "./render3D.vue?vue&type=style&index=0&id=10363294&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10363294",
  null
  
)

export default component.exports